export const FREE_TEXT_MODALITY_CODE = "base";

export const HERMESLAB_CATEGORY_CODE = "HERMESLAB";

/** Course type (Malla) that allows Hermeslab references, compared trimmed and case-insensitively. */
export const LABORATORY_COURSE_TYPE = "laboratorio";
